export type MutationResponse = {
  data?: Record<string, unknown> | null
  errors?: readonly unknown[]
}

export const mutationFailed = (result: MutationResponse): boolean =>
  Boolean(result.errors?.length) ||
  Object.values(result.data ?? {}).some(
    payload =>
      payload !== null &&
      typeof payload === "object" &&
      (payload as { success?: unknown }).success === false
  )

export const withMutationFeedback = async <T extends MutationResponse>(
  request: () => Promise<T>,
  reportError: (message: string) => void,
  message: string
): Promise<T | undefined> => {
  try {
    const result = await request()
    if (mutationFailed(result)) reportError(message)
    return result
  } catch {
    reportError(message)
    return undefined
  }
}
